<template>
  <div class="footer_wrap">
    <div class="footer_cont">
      <div class="footer_cleft">
        <div class="footer_cleftone">
          <div class="footer_clefthead">
            <div class="footer_clefthtext">Sobre</div>
            <div class="footer_clefthtext">Nosotros</div>
          </div>
          <div class="footer_cleftdown">
            <div class="footer_cleftdtext" @click="getActive('sobre')">Introducción de la Empresa</div>
          </div>
        </div>
        <div class="footer_clefttwo">
          <div class="footer_clefthead">
            <div class="footer_clefthtext">Garantías de</div>
            <div class="footer_clefthtext">Seguridad</div>
          </div>
          <div class="footer_cleftdown">
            <div class="footer_cleftdtext" @click="getActive('privacidad')">Acuerdo de Privacidad</div>
            <div class="footer_cleftdtext" @click="getActive('usuario')">Acuerdo de Usuario</div>
          </div>
        </div>
        <div class="footer_cleftthr">
          <div class="footer_clefthead">
            <div class="footer_clefthtext">Seguridad</div>
            <div class="footer_clefthtext"></div>
          </div>
          <div class="footer_cleftdown">
            <!--<div class="footer_cleftdtext">Atención al clientes：
               <p>5585264079</p>
            </div>-->
            <!--<div class="footer_cleftdtext">Whatsapp：
              <p></p>
            </div>-->
            <div class="footer_cleftdtext">Correo electrónico：
              <p>paramia.atc@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_cright">
        <div class="footer_googleplay" @click.stop="gotoGPlink">
          <img src="../assets/image/footer_googleplay.png" />
        </div>
        <div class="facebook_more" style="width: 296px; height: 56px;">
          <!--<img src="@/assets/imgs/facebook_more.webp" alt="">-->
          <div class="facebook_more_list">
            <a
                    href="https://www.facebook.com/profile.php?id=61575747896468"
                    target="_blank"
                    class="playBtn"
            >
              <div class="facebook_more_item">
                <img src="@/assets/image/facebook.webp" alt="">
              </div>
            </a>
            <a
                    href="https://www.instagram.com/paramia.mx/"
                    target="_blank"
                    class="playBtn"
            >
              <div class="facebook_more_item">
                <img src="@/assets/image/instagram.webp" alt="">
              </div>
            </a>
            <a
                    href="https://www.tiktok.com/@para.ma.prestamos"
                    target="_blank"
                    class="playBtn"
            >
              <div class="facebook_more_item">
                <img src="@/assets/image/tiktok.webp" alt="">
              </div>
            </a>
            <a
                    href="https://www.youtube.com/@ParaM%C3%ADamx"
                    target="_blank"
                    class="playBtn"
            >
              <div class="facebook_more_item">
                <img src="@/assets/image/youtube.webp" alt="">
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/foot.scss";

export default {
  name: "footPage",
  data() {
    return {};
  },
  methods: {
    gotoGPlink() {
      window.location.href = 'https://play.google.com/store/apps/details?id=mx.com.paramia'
    },
    getActive(val) {
      let url = '';
      switch (val) {
        case "sobre":
          url = "/about";
          break;
        case "privacidad":
          url = "/privacidad";
          break;
        case "usuario":
          url = "/usuario";
          break;
      }
      this.$router.push(url);
    }
  }
};
</script>
